import { Box, Grid, Modal, Typography } from "@mui/material";
import React from "react";
import { ModalHeader } from "./modalHeader";
import linkIcon from "../assets/linkIcon.png";
import smsIcon from "../assets/smsIcon.png";
import whatsappIcon from "../assets/wp.png";
import facebookIcon from "../assets/fbIcon.png";
import instaIcon from "../assets/instaIcon.png";

function ShareElegantModal({ handleClose, open }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="help-modal-title"
      aria-describedby="help-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          borderRadius: "10px",
          transform: "translate(-50%, -50%)",
          width: { lg: "35%", xs: "90%", md: "45%", sm: "80%" },
          bgcolor: "background.paper",
          boxShadow: 24,
        }}
      >
        <ModalHeader title={"Share Elegant Prime App "} onClose={handleClose} />
        <Box sx={{ padding: "20px" }}>
          <Box
            sx={{
              color: "#000",
              fontWeight: "500",
              border: "1px solid #8B8BDA",
              borderRadius: "10px",
              padding: "10px 15px",
              cursor: "pointer",
              whiteSpace: "normal",
              wordBreak: "break-all", // ✅ key addition
              overflowWrap: "break-word",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
            onClick={(e) => {
              navigator.clipboard.writeText(
                "https://play.google.com/store/apps/details?id=com.mybills.elegantprime&pcampaignid=web_share"
              );
              const range = document.createRange();
              range.selectNodeContents(e.target);
              const selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
            }}
          >
            https://play.google.com/store/apps/details?id=com.mybills.elegantprime&pcampaignid=web_share
          </Box>
          <Grid
            container
            spacing={3}
            sx={{
              marginTop: "0",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <Grid
              item
              xs={3}
              sm={2}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                onClick={(e) => {
                  navigator.clipboard.writeText(
                    "https://play.google.com/store/apps/details?id=com.mybills.elegantprime&pcampaignid=web_share"
                  );
                }}
                style={{
                  borderRadius: "50%",
                  display: "flex",
                  border: "1px solid #434343",
                }}
              >
                <Box
                  component="img"
                  src={linkIcon}
                  alt="icon"
                  sx={{
                    width: { xs: "24px", sm: "32px", md: "40px", lg:"100%" },
                    height: "auto",
                  }}
                />
              </span>
              <Typography
                component="span"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  marginTop: "10px",
                  fontWeight: 500,
                }}
              >
                Link
              </Typography>
            </Grid>
            <Grid
              item
              xs={3}
              sm={2}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={smsIcon}
                alt="icon"
                sx={{
                  width: { xs: "40%", sm: "50%", md: "70%", lg: "100%" },
                  height: "auto",
                  cursor: "pointer",
                }}
              />
              <Typography
                component="span"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  marginTop: "10px",
                  fontWeight: 500,
                }}
              >
                Mail
              </Typography>
            </Grid>
            <Grid
              item
              xs={3}
              sm={2}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={whatsappIcon}
                alt="icon"
                sx={{
                  width: { xs: "40%", sm: "50%", md: "70%", lg: "100%" },
                  height: "auto",
                  cursor: "pointer",
                }}
              />
              <Typography
                component="span"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  marginTop: "10px",
                  fontWeight: 500,
                }}
              >
                Whatsapp
              </Typography>
            </Grid>
            <Grid
              item
              xs={3}
              sm={2}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={instaIcon}
                alt="icon"
                sx={{
                  width: { xs: "40%", sm: "50%", md: "70%", lg: "100%" },
                  height: "auto",
                  cursor: "pointer",
                }}
              />
              <Typography
                component="span"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  marginTop: "10px",
                  fontWeight: 500,
                }}
              >
                Instagram
              </Typography>
            </Grid>
            <Grid
              item
              xs={3}
              sm={2}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={facebookIcon}
                alt="icon"
                sx={{
                  width: { xs: "40%", sm: "50%", md: "70%", lg: "100%" },
                  height: "auto",
                  cursor: "pointer",
                }}
              />
              <Typography
                component="span"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  marginTop: "10px",
                  fontWeight: 500,
                }}
              >
                Facebook
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
}

export default ShareElegantModal;
